import { createFileRoute } from '@tanstack/react-router';
import { useAnalytics } from '~/hooks';
import { Splash } from '~/pages';
import { protectRoute } from '~/utilities';

import { useEffect } from 'react';
import { trackPageView } from '~/hooks';

export const Route = createFileRoute('/')({
  component: IndexComponent,
  beforeLoad: protectRoute,
});

function IndexComponent() {
  const analyticsInitialized = useAnalytics();

  useEffect(() => {
    if (analyticsInitialized) {
      trackPageView('mpl_splash_page_viewed', {
        path: window.location.pathname,
      });
    }
  }, [analyticsInitialized]);

  return <Splash />;
}
